import { ColumnDef, ColumnHelper } from '@tanstack/react-table'

import { commonAccessorColumn, dateAccessorColumn, moneyAccessorColumn } from '@/components/table'
import { MerchantCell, QrLink, StatusCell } from '@/components'
import { C2BQr } from '@/types.ts'

import { DeleteStaticQr } from './components/delete-static-qr.tsx'

export const KEY_PAGE = 'c2b'

type VisibleColumns =
  | 'requestId'
  | 'reference'
  | 'paymentPurpose'
  | 'amount'
  | 'qrcType'
  | 'isQrActive'
  | 'expireQr'
  | 'payload'
  | 'qrcId'
  | 'merchantId'

export type PartialC2BQr = Pick<C2BQr, VisibleColumns> & { 'delete-static-action': string }

export const defaultSettings: Record<keyof PartialC2BQr, string> = {
  requestId: '№',
  reference: '№ заказа в магазине',
  paymentPurpose: 'Назначение платежа',
  amount: 'Сумма платежа',
  qrcType: 'Тип QR',
  isQrActive: 'Статус',
  expireQr: 'Срок действия',
  payload: 'Платёжная ссылка',
  'delete-static-action': 'Кнопка «Удалить»',
  qrcId: 'ID QR в СБП',
  merchantId: 'ТСП',
}

export function getColumnsSettings(
  columnHelper: ColumnHelper<C2BQr>
): Record<keyof PartialC2BQr, ColumnDef<C2BQr, any>> {
  return {
    requestId: columnHelper.accessor('requestId', commonAccessorColumn('№')),
    reference: columnHelper.accessor('reference', commonAccessorColumn('№ заказа в магазине')),
    // todo: какая таймзона?
    paymentPurpose: columnHelper.accessor('paymentPurpose', commonAccessorColumn('Назначение платежа')),
    amount: columnHelper.accessor('amount', moneyAccessorColumn('Сумма платежа')),
    qrcType: columnHelper.accessor('qrcType', {
      header: 'Тип QR',
      enableSorting: false,
      cell: (props) => (props.getValue() === '02' ? 'Динамика' : 'Статика'),
    }),
    isQrActive: columnHelper.accessor('isQrActive', {
      header: 'Статус',
      enableSorting: false,
      cell: (props) => <StatusCell isActive={props.getValue()} />,
    }),
    // todo: поменять валюту rur на rub?
    expireQr: columnHelper.accessor('expireQr', dateAccessorColumn('Срок действия', true)),
    payload: columnHelper.accessor('payload', {
      header: 'Платёжная ссылка',
      enableSorting: false,
      cell: (props) => <QrLink value={props.getValue()} {...props.row.original} />,
    }),
    'delete-static-action': columnHelper.display({
      id: 'delete-static-action',
      enableSorting: false,
      cell: (props) => <DeleteStaticQr {...props.row.original} />,
    }),
    qrcId: columnHelper.accessor('qrcId', commonAccessorColumn('ID QR в СБП')),
    merchantId: columnHelper.accessor('merchantId', {
      header: 'ТСП',
      enableSorting: false,
      cell: (props) => <MerchantCell merchantId={props.getValue()} />,
    }),
  }
}
